import { routes } from "routing";
import { lazyView, type RouteRender } from "routing/tree";
import i18n from "i18n/i18next";

const { account } = routes;
const { settings } = account;

/** Every account screen is code-split; none are reachable without opening Account first. */
export const accountRoutes: RouteRender[] = [
  lazyView(account.page, () => import("./account").then((m) => ({ default: m.AccountPage })), "Account"),
  lazyView(
    account.profile,
    () => import("./profile/account-profile").then((m) => ({ default: m.AccountProfilePage })),
    "Profile",
  ),
  lazyView(
    account.profileEdit,
    () => import("./profile/edit/account-profile-edit").then((m) => ({ default: m.AccountProfileEditPage })),
    () => i18n.t("account.profile.title"),
  ),
  lazyView(
    account.dateTimePicker,
    () =>
      import("app/edit/date-time-picker/edit-date-time-picker").then((m) => ({ default: m.EditDateTimePickerPage })),
    "",
  ),
  lazyView(
    account.profilePickupAddress,
    () =>
      import("./profile/edit/pickup-address/account-profile-edit-pickup-address").then((m) => ({
        default: m.AccountProfileEditPickupAddressPage,
      })),
    "Pick-up Address",
  ),
  lazyView(
    account.delete,
    () => import("./delete/account-delete").then((m) => ({ default: m.AccountDeletePage })),
    "Delete Account",
  ),
  lazyView(
    account.organisations,
    () => import("./organisations/account-organisations").then((m) => ({ default: m.AccountOrganisationsPage })),
    () => i18n.t("account.swapTeam"),
  ),
  lazyView(
    account.accessRequests,
    () => import("./access-requests/account-access-requests").then((m) => ({ default: m.AccountAccessRequestsPage })),
    "Access Requests",
  ),
  lazyView(
    account.subscription,
    () => import("./subscription/account-subscription").then((m) => ({ default: m.AccountSubscriptionPage })),
    () => i18n.t("account.subscriptions"),
  ),
  lazyView(settings.page, () => import("./settings/account-settings"), "Settings"),
  lazyView(
    settings.about,
    () => import("./settings/about/account-settings-about").then((m) => ({ default: m.AccountSettingsAboutPage })),
    "About",
  ),
  lazyView(
    settings.licences,
    () =>
      import("./settings/about/licences/account-settings-about-licences").then((m) => ({
        default: m.AccountSettingsAboutLicencesPage,
      })),
    "Licences",
  ),
  lazyView(
    settings.credits,
    () =>
      import("./settings/about/credits/account-settings-about-credits").then((m) => ({
        default: m.AccountSettingsAboutCreditsPage,
      })),
    "Credits",
  ),
  lazyView(settings.themes, () => import("./settings/themes/account-settings-themes"), "Themes"),
  lazyView(
    settings.booking,
    () => import("./settings/booking/account-settings-booking"),
    () => i18n.t("account.booking"),
  ),
  lazyView(settings.language, () => import("./settings/language/account-settings-language"), "Language"),
  lazyView(
    settings.time,
    () => import("./settings/time/account-settings-time").then((m) => ({ default: m.AccountSettingsTimePage })),
    "Time",
  ),
  lazyView(settings.calendar, () => import("./settings/calendar/account-settings-calendar"), "Calendar"),
  lazyView(settings.widgets, () => import("./settings/widgets/account-settings-widgets"), "Widgets"),
  lazyView(
    settings.homeScreen,
    () =>
      import("./settings/home-screen/account-settings-home-screen").then((m) => ({
        default: m.AccountSettingsHomeScreenPage,
      })),
    () => i18n.t("navbar.home"),
  ),
  lazyView(settings.team, () => import("./settings/team/account-settings-team"), "Team"),
  lazyView(
    settings.notifications,
    () => import("./settings/notifications/account-settings-notifications"),
    "Notifications",
  ),
  lazyView(
    settings.localNotifications,
    () => import("./settings/notifications/local/account-settings-notifications-local"),
    "Local Notifications",
  ),
  lazyView(
    settings.localNotificationsPending,
    () =>
      import("./settings/notifications/local/pending/account-settings-notifications-local-pending").then((m) => ({
        default: m.AccountSettingsNotificationsLocalPendingPage,
      })),
    () => i18n.t("account.local-notification.pending"),
  ),
  lazyView(
    settings.chatNotifications,
    () => import("./settings/notifications/chat/account-settings-notifications-chat"),
    "Chat Notifications",
  ),
];
